import "@livekit/components-styles";
import { LiveKitRoom, RoomAudioRenderer } from "../livekit-lib";
import { VideoConference } from "../livekit-lib/VideoConference";
import React, { useEffect, useState } from "react";
import "./JoinRoom.css";
import { useNavigate } from "react-router-dom";
import { clearSessionDetails } from "../../services/storage.service";
import { useRecoilState, useSetRecoilState } from "recoil";
import { isMeeetingDisconnected, isMeetingTerminated, participantDetailState, showForceUpdateDialogState, showHeaderState } from "../../atom/atom";
import { DebugMode } from "../../debug";
import { DisconnectReason, LogLevel } from "livekit-client";
import { log } from "@livekit/components-core";
import {getDataFromLocalStorage} from '../../services/storage.service'
import { getStaticConfig } from "../../services/config.service";
import Loading from "../../utils/Loading";
import {staticConfigAtom} from '../../atom/atom'
import useSnackbar from "../../utils/useSnackbar";
import { StaticConfig } from "../../models/IStaticConfig";
import { isForceUpdateRequired } from "../../services/updateChecker.service";
import { TokenPayload } from "../../models/IToken";
import TokenService from "../../services/token.service";

const JoinRoom: React.FC = () => {
  const [token, setToken] = useState("");
  const navigate = useNavigate();
  const setShowHeader = useSetRecoilState(showHeaderState);
  const setShowForceUpdateDialog = useSetRecoilState(showForceUpdateDialogState);
  const [staticConfig, setStaticConfig] = useRecoilState(staticConfigAtom)
  const [isLoading, setIsLoading] = useState(false);
  const { showSnackbar, SnackbarComponent } = useSnackbar();
  const setIsMeetingTerminated = useSetRecoilState(isMeetingTerminated);
  const setMeetingDisconnectedState = useSetRecoilState(isMeeetingDisconnected);
  const setParticpantDetails = useSetRecoilState(participantDetailState);


  useEffect(() => {
    const storedToken = localStorage.getItem("token") ?? "";
    setToken(storedToken);
    setShowHeader(false);

    const fetchConfig = async () => {
      try {
        setIsLoading(true);

        await getStaticConfig();
        const fetchedConfig = getDataFromLocalStorage('staticConfig');

        await handleCheckForceUpdate(fetchedConfig);

        setStaticConfig(fetchedConfig);

        setIsLoading(false);
      } catch (error) {
        showSnackbar({message: 'Something went wrong, please try rejoin meeting.', severity: 'warning'});
        navigate('/');
        console.error('Error fetching static config:', error);
      }
    };

    fetchConfig();
  }, [navigate]);

  const handleCheckForceUpdate = async (fetchedConfig: StaticConfig) => {
    const forceUpdateRequired = await isForceUpdateRequired(fetchedConfig);

    if (forceUpdateRequired) {
      setShowForceUpdateDialog(true);
      navigate("/");
      clearSessionDetails();
    }
  };

  if (!staticConfig) {
    return <Loading open={isLoading} />
  }

    const getParticipantName = () => {
      let parsedToken: TokenPayload = TokenService.parseToken(true, "");
      let participantDetails = JSON.parse(parsedToken.metadata);
      return participantDetails.pName;
    };

    const getParticipantEmail = () => {
      let parsedToken: TokenPayload = TokenService.parseToken(true, "");
      let participantDetails = JSON.parse(parsedToken.metadata);
      return participantDetails.pEmail;
    };

      const getSessionId = () => {
        let parsedToken: TokenPayload = TokenService.parseToken(true, "");
        return parsedToken.video.room;
      };

    const meetingDisconnected = () => {
      setMeetingDisconnectedState(true);
      setParticpantDetails({
       participantEmail: getParticipantEmail(),
       participantName: getParticipantName(),
      sessionId: getSessionId(),
      })
      clearSessionDetails();
      navigate("/");
      alert("You’ve been disconnected from the meeting. Please check your internet connection and try rejoining.");
    }

  return (
    <>
    {SnackbarComponent}
    <LiveKitRoom
      key={new Date().getTime()}
      video={false}
      audio={false}
      token={token}
      serverUrl={staticConfig.sessionProvider}
      data-lk-theme="default"
      style={{ height: "100vh" }}
      onDisconnected={(reason?: DisconnectReason) => {
        setShowHeader(true);
        switch (DisconnectReason[reason ?? 8]) {
          case "ROOM_DELETED":
            navigate("/feedback");
            setIsMeetingTerminated(true);
            break;
          case "UNKNOWN_REASON":
            setShowHeader(false);
            navigate("/session");
            break;
          default:
            meetingDisconnected();
            break;
        }
        log.error("Disconnect reason ", DisconnectReason[reason ?? 0]);
      }}
    >
      <VideoConference />
      <RoomAudioRenderer />
      <DebugMode
        logLevel={
          !!(window as any).electronAPI ? LogLevel.info : LogLevel.silent
        }
      />
    </LiveKitRoom>
    </>
  );
};

export default JoinRoom;
